import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import _isEmpty from "lodash-es/isEmpty";
import classNames from "classnames";
import Typography from "antd/es/typography";

import Form from "src/bepaid/components/Form";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import MainLayout from "src/bepaid/layouts/MainLayout";

import styles from "./OnboardingRequirements.module.scss";
import Button from "src/bepaid/components/Form/controls/Button";
// import { FetchModalID } from "src/ipm-shared/components/GlobalUI/actions";
// import { MY_INFO_MODES } from "../../const";
import { FetchModalID } from "src/ipm-platform/layout/actions";
import { MY_INFO_MODES } from "../../const";
import { history } from "src/ipm-shared/store";
import ROUTES from "src/bepaid/routes";
import { COUNTRY_REQUIREMENTS } from "./const";

const RequirementsList = ({ countryCode }: { countryCode: string }) => {
  const items = COUNTRY_REQUIREMENTS[countryCode] || COUNTRY_REQUIREMENTS.SG;

  return (
    <ol>
      {items.map((item, index) => (
        <li key={index} className={styles.purpleText}>
          <span>{item.description}</span>
          {item.nested && (
            <ol className={styles.nestedList}>
              {item.nested.map((text, i) => (
                <li key={i}>{text}</li>
              ))}
            </ol>
          )}
        </li>
      ))}
    </ol>
  );
};

const FormComponent = (props: any) => {
  const { countryCode } = props;

  return (
    <Form
      name="my-info-login-identity-form"
      layout="vertical"
      requiredMark={false}
      className={styles.form}
    >
      <div className={styles.itemSection}>
        <div className={styles.itemText}>
          <Typography.Text>
            Please ensure that all documents listed below are complete and ready
            for submission. Missing or incomplete documents may delay account
            approval. You will only be able to make payments once your account
            has been approved.
          </Typography.Text>
        </div>
        <RequirementsList countryCode={countryCode} />
      </div>
    </Form>
  );
};

const OnboardingRequirements: React.FC<any> = props => {
  const {
    onClose,
    setExtraInfoState,
    openModal,
    countryCode,
    redirectUrl
  } = props;

  const [loading, setLoading] = React.useState(false);

  const renderButton = () => (
    <div className={styles.button}>
      <div className={styles.italicNoteText}>
        <Typography.Text>
          Completing this form takes approximately 5–7 minutes if you have all
          the required documents ready.
        </Typography.Text>
      </div>
      <Button
        type="primary"
        htmlType="submit"
        loading={loading}
        onClick={onSubmit}
      >
        {loading ? "Continue..." : "Continue"}
      </Button>
    </div>
  );

  const onSubmit = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);

      if (countryCode !== "SG") {
        const destination = redirectUrl || ROUTES.ROOT;
        const backUrl = `${ROUTES.MY_INFO}${window.location.search}`;
        history.push(
          `${ROUTES.KYC}?redirect_url=${encodeURIComponent(
            destination
          )}&back_url=${encodeURIComponent(backUrl)}`
        );
        return;
      }

      setExtraInfoState({
        mode: MY_INFO_MODES.login,
        isBiz: true
      });
      openModal(FetchModalID.MY_INFO_VERIFICATION_MODAL);
    }, 500);
  };

  return (
    <>
      <BrowserView>
        <DesktopModalLayout
          title={"Onboarding Requirements"}
          // onBack={extraInfoState.isBiz && onBack}
          onClose={onClose}
          onSubmit={onSubmit}
          btnSubmit={renderButton()}
          submitButtonClassName={styles.submitButton}
        >
          <div className={classNames(styles.wrapper, styles.wrapperDesktop)}>
            <FormComponent {...props} />
          </div>
        </DesktopModalLayout>
      </BrowserView>
      <MobileView>
        <MainLayout
          header={{
            title: "Onboarding Requirements",
            // onBack: extraInfoState.isBiz && onBack,
            onClose,
            hideMenu: true
          }}
          footer={renderButton()}
        >
          <div className={styles.wrapper}>
            <FormComponent {...props} />
          </div>
        </MainLayout>
      </MobileView>
    </>
  );
};

export default OnboardingRequirements;
